import { onApiError } from "../error"
import { state } from "../state"
import { post } from "./client"

/**
 * @param {string} Token
 */
async function postDeviceToken(Token) {
    const user = await state.getSignedInUser()
    const res = await post(`/users/${user.Id}/device-tokens`, {
        body: JSON.stringify({ Token })
    })

    if (!res.ok) throw await onApiError(res)
    return true
}

export {
    postDeviceToken
}